import React from 'react'
import '../../Styles/AdditionalPages/Thoughts.css'

export default function Thoughts() {
  return (
    <div className='thoughts'>
        <div className="thoughtscontainer">
          <h1 className="thoughtshead">CHAIRMAN THOUGHTS</h1>
          <div className="thoughtsbox">
            <div className="thoughtsimg"> </div>
            <div className="thoughtspara">
              <div className="thoughtspara1">जिस शिक्षा से हम अपना जीवन निर्माण कर सके, मनुष्य बन सके, चरित्र गठन कर सके और विचारों का सामंजस्य कर सके। वही वास्तव में शिक्षा कहलाने योग्य है।</div>
            </div>
          </div>
        </div>
    </div>
  )
}
